import { EventHubHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';

export const DRAWER_EVENT_HUB_MODULE = '@drawer';

export enum DrawerActions {
	hide = '@drawer/hide',
	show = '@drawer/show',
}

export class DrawerHelper {
	static show(name: string): void {
		EventHubHelper.emit({ type: DrawerActions.show, id: name, module: DRAWER_EVENT_HUB_MODULE });
	}

	static hide(name: string): void {
		EventHubHelper.emit({ type: DrawerActions.hide, id: name, module: DRAWER_EVENT_HUB_MODULE });
	}
}
